import api from "../../../api/axios";

// Feature-local wrappers for the per-row REST endpoints of
// ClientContact. Each function maps 1:1 to one HTTP verb against the
// existing backend routes (per backend/app/apps/clients/urls.py:32-41).
//
// Auth: IsAuthenticated.
// Permission:
//   GET                — IsClientAccessible (owner OR active share).
//   POST/PATCH/DELETE  — IsClientWriter (owner OR active can_edit share).

const basePath = (clientId) => `/crm/clients/${clientId}/contacts/`;
const rowPath = (clientId, contactId) =>
  `/crm/clients/${clientId}/contacts/${contactId}/`;

export const fetchClientContacts = (clientId) =>
  api.get(basePath(clientId)).then((res) => res.data);

export const createClientContact = (clientId, payload) =>
  api.post(basePath(clientId), payload).then((res) => res.data);

export const updateClientContact = (clientId, contactId, payload) =>
  api.patch(rowPath(clientId, contactId), payload).then((res) => res.data);

export const deleteClientContact = (clientId, contactId) =>
  api.delete(rowPath(clientId, contactId)).then(() => undefined);
